import axios from "axios";
export default class Api {
  static downloadAsset = (caption, albumName, pdfName, direction) => {
    return axios.get(`/isi/DownloadIsiPdf`, {
      responseType: "blob",
      headers: { Accept: "application/pdf" },
      params: {
        albumName: albumName,
        caption: caption,
        pdfName: pdfName,
        direction: direction,
      },
    });
  };

  static getAvailablePdfByCaptions = (captions, albumName) => {
    var queryString = new URLSearchParams();
    queryString.append("albumName", albumName);
    captions.forEach((name) => {
      queryString.append("caption", name);
    });
    return axios.get(`/isi/getAvailableCaptions`, {
      headers: { Accept: "application/pdf" },
      params: { queryString: queryString.toString() },
    });
  };

  static getDiscountCodeValidity = (discountCode, skuId, url) => {
    return axios.get(url, {
      responseType: "json",
      params: {
        discountCode: discountCode,
        skuId: skuId,
      },
    });
  };

  static getFreeEticketsValidity = (url, eticketPrice, email, startDate) => {
    return axios.get(url, {
      responseType: "json",
      params: {
        eticketPrice: eticketPrice,
        email: email,
        startDate: startDate,
      },
    });
  };
}



// WEBPACK FOOTER //
// ./src/api/api.js